import _ from 'lodash'
import Backbone from 'backbone'

/**
 * Returns a deep clone of the object, using Backbone's built-in cloning for
 * any Models and Collections in the object tree.
 */
function cloneDeepWithModels (obj) {
	return _.cloneDeepWith(obj, value => {
		if (value instanceof Backbone.Model || value instanceof Backbone.Collection) {
			// This particular property in the object hierarchy (could be many
			// levels deep) is a Backbone Model/Collection. _.cloneDeep() will
			// end up cloning all kinds of objects that have relevant event
			// listeners (like Backbone Views), and we don't want those cloned.
			// So just use Backbone's built-in cloning for these.
			return value.clone()
		}
		// If nothing returned, _.cloneDeepWith() will use its built-in cloning
		// for this property
	})
}

export default cloneDeepWithModels

cloneDeepWithModels.__filename__ = 'components/clone-deep-with-models.js'
